import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { LanguageCode } from "../../utils/translations";
import { HOME_COPY } from "./homeContent";
import SectionHeading from "./SectionHeading";
import ScrollRow from "./ScrollRow";
import { HOME_THEME, sectionPadding } from "./theme";

const catStyle = (category: string): React.CSSProperties =>
  category === "Social Media"
    ? { background: HOME_THEME.primarySoft, color: HOME_THEME.primaryDark }
    : { background: HOME_THEME.accentSoft, color: "#B45309" };

interface CapabilitiesProps {
  lang: LanguageCode;
}

const Capabilities: React.FC<CapabilitiesProps> = ({ lang }) => {
  const { eyebrow, title, subtitle, items } = HOME_COPY[lang].capabilities;

  return (
    <section style={{ padding: sectionPadding, background: HOME_THEME.surface }}>
      <ScrollRow
        ariaLabel="Capabilities"
        header={
          <SectionHeading
            align="center"
            noMargin
            eyebrow={eyebrow}
            title={title}
            subtitle={subtitle}
          />
        }
      >
        {items.map((c) => (
          <Link
            key={c.title}
            to={c.to}
            style={{
              textDecoration: "none",
              flex: "0 0 auto",
              width: "290px",
              scrollSnapAlign: "start",
            }}
          >
            <div
              style={{
                height: "100%",
                boxSizing: "border-box",
                background: HOME_THEME.surfaceAlt,
                border: `1px solid ${HOME_THEME.border}`,
                borderRadius: "14px",
                padding: "18px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <span
                style={{
                  alignSelf: "flex-start",
                  fontSize: "0.72rem",
                  fontWeight: 800,
                  letterSpacing: "0.5px",
                  textTransform: "uppercase",
                  padding: "5px 12px",
                  borderRadius: "999px",
                  marginBottom: "14px",
                  ...catStyle(c.category),
                }}
              >
                {c.tag}
              </span>

              <h3
                style={{
                  margin: "0 0 8px 0",
                  fontSize: "1.1rem",
                  fontWeight: 700,
                  color: HOME_THEME.heroHeading,
                }}
              >
                {c.title}
              </h3>
              <p
                style={{
                  margin: "0 0 16px 0",
                  color: HOME_THEME.muted,
                  fontSize: "0.9rem",
                  lineHeight: 1.55,
                  flex: 1,
                }}
              >
                {c.desc}
              </p>
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  color: HOME_THEME.primary,
                  fontWeight: 700,
                  fontSize: "0.85rem",
                }}
              >
                Learn more <ArrowRight size={15} />
              </span>
            </div>
          </Link>
        ))}
      </ScrollRow>
    </section>
  );
};

export default Capabilities;
